module.exports = __webpack_public_path__ + "img/lxkh.b8e1765c.png";